'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasExpiredByMonths = exports.getDateType = exports.defaultScopeDates = exports.textInputFormat = undefined;

var _format = require('date-fns/format');

var _format2 = _interopRequireDefault(_format);

var _sub_years = require('date-fns/sub_years');

var _sub_years2 = _interopRequireDefault(_sub_years);

var _sub_months = require('date-fns/sub_months');

var _sub_months2 = _interopRequireDefault(_sub_months);

var _is_before = require('date-fns/is_before');

var _is_before2 = _interopRequireDefault(_is_before);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // All formats support delimiters of / \ - . and space


var DATE_FORMATS_REGEX = [// formats of: MM-YYYY | MM-DD-YYYY | DD-MM-YYYY | DD-MMM
/^\d{1,2}(\/|\\|-|\.|\s)(?:(?:january|february|march|april|may|june|july|august|september|october|november|december)|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec))$/i, /^\d{1,2}(\/|\\|-|\.|\s)\d{1,2}\1\d{2,4}$/, /^\d{1,2}(?:\/|\\|-|\.|\s)\d{2,4}$/, // formats of: YYYY-MM-DD | YYYY-DD-MM | YYYY-MM | DDD MMM, YYYY
/^\d{2,4}(?:\/|\\|-|\.|\s)\d{1,2}$/, /^\d{2,4}(\/|\\|-|\.|\s)\d{1,2}\1\d{1,2}$/, /^\d{2,4}(?:\/|\\|-|\.|\s)(?:(?:january|february|march|april|may|june|july|august|september|october|november|december)|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec))$/i, /^(?:(?:monday|tuesday|wednesday|thursday|friday|saturday|sunday)|(?:mon|tue|wed|thu|fri|sat|sun))\s(?:january|february|march|april|may|june|july|august|september|october|november|december)|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec),\s\d{2,4}$/i, // formats of: DD-MMM-YYYY | MMM-YYYY | MMM-DDD-YYYY | MMM-DDD | MMMM-YYYY | MMM DD, YYYY | DDD, MMMM DD, YYYY
/^(?:(?:january|february|march|april|may|june|july|august|september|october|november|december)|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec))(?:\/|\\|-|\.|\s)\d{2,4}$/i, /^(?:(?:january|february|march|april|may|june|july|august|september|october|november|december)|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec))(\/|\\|-|\.|\s)(?:(?:monday|tuesday|wednesday|thursday|friday|saturday|sunday)|(?:mon|tue|wed|thu|fri|sat|sun))(\1\d{2,4})?$/i, /^(?:\d{1,2}(\/|\\|-|\.|\s))(?:(?:january|february|march|april|may|june|july|august|september|october|november|december)|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec))(?:\1\d{2,4})$/i, /^(?:(?:(?:monday|tuesday|wednesday|thursday|friday|saturday|sunday)|(?:mon|tue|wed|thu|fri|sat|sun)),\s)?(?:(?:january|february|march|april|may|june|july|august|september|october|november|december)|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec))\s\d{1,2},\s\d{2,4}$/i];
var DATE_TIME_FORMATS_REGEX = [// formats of: MM-DD-YYYY HH:mm
/^\d{1,2}(\/|\\|-|\.|\s)\d{1,2}\1\d{2,4}\s\d{1,2}:\d{1,2}:?\d{1,2}\s?(?:am|pm)?$/i, // formats of: YYYY-MM-DD HH:mm | YYYY-MM-DD HH:mm:ss | YYYY-MM-DDTHH:mm:ss | YYYY-MM-DDTHH:mm:ssZ | YYYY-MM-DDTHH:mm:ss-zone
/^\d{2,4}(\/|\\|-|\.|\s)\d{1,2}\1\d{1,2}(?:\s|T)\d{1,2}:\d{1,2}:?\d{1,2}Z?\s?(?:am|pm)?(?:-\d{1,2}:\d{1,2})?$/i, // formats of: MMMM DD, YYYY HH:mm | MMM DD, YYYY HH:mm
/^(?:(?:january|february|march|april|may|june|july|august|september|october|november|december)|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec))\s\d{1,2},\s\d{2,4}\s\d{1,2}:?\d{1,2}?:?\d{1,2}?(?:\s?am?|\s?pm?)?$/i];
var dateFormat = 'YYYY-MM-DD';

function textInputFormat(d) {
  return (0, _format2.default)(new Date(d), dateFormat);
}

function defaultScopeDates() {
  var lower = (0, _sub_years2.default)(Date.now(), 5);
  var upper = Date.now();
  return [lower, upper].map(function (d) {
    return textInputFormat(d);
  });
}

function getDateType(str) {
  if (str == null) {
    str = null;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Array.from(DATE_FORMATS_REGEX)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var regex = _step.value;

      if (regex.test(str)) {
        return 'date';
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = Array.from(DATE_TIME_FORMATS_REGEX)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _regex = _step2.value;

      if (_regex.test(str)) {
        return 'date-time';
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return null;
}
/**
 * Detects if a date is older than x months
 * @param  {*}       date   readable by new Date()
 * @param  {Number}  months number of months
 * @return {Boolean}        true if date is older than given # months
 */


function hasExpiredByMonths(date, months) {
  // terrible workaround, we want to accept both milliseconds and seconds
  // timestamps, but there's no way to discern the two, so we just consider
  // anything below "minMillisecondsTimestamp" as seconds timestamp
  var minMillisecondsTimestamp = 99999999999;
  var timestamp = new Date(date);
  date = new Date(timestamp > minMillisecondsTimestamp ? timestamp : date * 1000);
  var expiredAge = (0, _sub_months2.default)(new Date(), months);
  return (0, _is_before2.default)(date, expiredAge);
}

exports.textInputFormat = textInputFormat;
exports.defaultScopeDates = defaultScopeDates;
exports.getDateType = getDateType;
exports.hasExpiredByMonths = hasExpiredByMonths;